import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "src/router/RoutersCst";
import DashboardCorporatePage from "@pages/Contents/Corporate/Dashboard";
import UsersRolesAssociation from "@pages/Contents/Corporate/Dashboard/UsersRolesAssociation";
import UsersAssociationDashboard from "@pages/Contents/Corporate/Dashboard/UsersRolesAssociation/UsersAssociation";
import DashboardVisualization from "@pages/Contents/Corporate/Dashboard/DashboardVisualization";

const useCorporateDashboard = () => {
  const { isInclude } = useIsInclude();

  return {
    path: "dashboard",
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute
            isAllowed={isInclude(
              "corporate&&smartconfigurator.quicksight.read",
            )}
          >
            <DashboardCorporatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "users-roles",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&smartconfigurator.quicksight.associate.users.roles",
                )}
              >
                <UsersRolesAssociation />
              </ProtectedRoute>
            ),
          },
          {
            index: false,
            path: ":dashboardId/users-association",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&smartconfigurator.quicksight.associate.users.roles",
                )}
              >
                <UsersAssociationDashboard />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "visualization",
        element: (
          <ProtectedRoute
            isAllowed={isInclude(
              "corporate&&smartconfigurator.quicksight.read",
            )}
          >
            <DashboardVisualization />
          </ProtectedRoute>
        ),
      },
    ],
  };
};

export default useCorporateDashboard;
